export const smoothScrollToPosition = (top: number = 0) => {
  try {
    window.scrollTo({
      top,
      left: 0,
      behavior: 'smooth',
    });
  } catch (e) {
    window.scrollTo(0, top);
  }
};
